"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var arrow_left_icon_svg_1 = __importDefault(require("@assets/widgets/app/arrow-left-icon.svg"));
var arrow_right_icon_svg_1 = __importDefault(require("@assets/widgets/app/arrow-right-icon.svg"));
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        pageSelectGrid: {
            fontWeight: 500,
            color: '#767676',
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            zIndex: 1,
        },
        pageSelectGridDirectory: {
            fontWeight: 500,
            color: '#767676',
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            zIndex: -1,
        },
        gridItemHorizontalPadding: {
            '&:first-child': {
                paddingRight: 34,
            },
            '&:last-child': {
                paddingLeft: 34,
            },
        },
    });
});
var PaginationActionComponent = function (_a) {
    var pageCount = _a.pageCount, onChangePage = _a.onChangePage, page = _a.page, _b = _a.disablePagination, disablePagination = _b === void 0 ? false : _b;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, alignItems: "center", className: disablePagination
            ? classes.pageSelectGridDirectory
            : classes.pageSelectGrid },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function (event) { return onChangePage(event, page - 1); }, disabled: page <= 0 },
                react_1.default.createElement("img", { src: arrow_left_icon_svg_1.default, alt: "Previous page", draggable: false }))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding }, "Page ".concat(page + 1, " of ").concat(pageCount)),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.gridItemHorizontalPadding },
            react_1.default.createElement(core_1.IconButton, { onClick: function (event) { return onChangePage(event, page + 1); }, disabled: pageCount <= page + 1 },
                react_1.default.createElement("img", { src: arrow_right_icon_svg_1.default, alt: "Next page", draggable: false })))));
};
exports.default = PaginationActionComponent;
